import axios from 'axios'
import qs from 'querystring'
import store from '../store/store._index'

const model = {
  get apiBasePath() {
    return store.getters.getApiBasePath
  }
}
export default {
  getPage,
  getMenu,
  getTabs,
  getAllNews,
  getNews,
  getLastNews,
  getFile,
  sendSedForm,
  sendTechSupportForm,
  getPartners,
  getPartner,
  getVacancies,
  getVacancy,
  getFooterSettings,
  getContactsSettings,
  getPagesLinks,
  getSiteMap,
  getClientSettings,
  sendFeedbackEmail,
  sendSupportEmail,
  getSearchResult,
  getHeaderSettings,
  loginWelcomebook,
  getPageWelcomebook,
  sendResume,
  getImageFile,
  loginAskodChatUser,
  deleteAskodChatUser,
  sendConsultationForm
}

async function getPage(urlKey, args) {
  const result = await axios.get(`${model.apiBasePath}/page/${urlKey}`)
  var data = result.data
  data.args = args
  return data
}

async function getMenu() {
  const result = await axios.get(`${model.apiBasePath}/page/getmenu`)
  return result.data
}

async function getTabs(tabIds) {
  var query = tabIds.map(item => `ids=${item}`).join('&')
  const result = await axios.get(`${model.apiBasePath}/page/tabs?${query}`)
  return result.data
}

async function getAllNews(page) {
  const result = await axios.get(`${model.apiBasePath}/news`, { params: page })
  return result.data
}

async function getNews(urlKey) {
  const result = await axios.get(`${model.apiBasePath}/news/${urlKey}`)
  return result.data
}

async function getLastNews() {
  const result = await axios.get(`${model.apiBasePath}/news/lastnews`)
  return result.data
}

async function getFile(id) {
  const result = await axios.get(`${model.apiBasePath}/file/${id}`, { responseType: 'blob' })
  var header = result.headers['content-disposition']
  header = header.slice(header.indexOf("UTF-8''") + 7)
  var fileName = header
  var file = new File([result.data], fileName, { type: result.data.type })
  return file
}

async function sendSedForm(form) {
  await axios.post(`${model.apiBasePath}/feedback/sed`, form)
}

async function sendTechSupportForm(form) {
  await axios.post(`${model.apiBasePath}/feedback/techsupport`, form)
}

async function getPartners(filterModel) {
  const result = await axios.get(`${model.apiBasePath}/partners`, {
    params: filterModel,
    paramsSerializer: params => {
      return qs.stringify(params)
    }
  })
  return result.data
}

async function getVacancies(filterModel) {
  const result = await axios.get(`${model.apiBasePath}/vacancy`, { params: filterModel })
  return result.data
}

async function getVacancy(urlKey) {
  const result = await axios.get(`${model.apiBasePath}/vacancy/${urlKey}`)
  return result.data
}

async function getFooterSettings() {
  const result = await axios.get(`${model.apiBasePath}/clientsettings/footer`)
  return result.data
}

async function getContactsSettings() {
  const result = await axios.get(`${model.apiBasePath}/clientsettings/contacts`)
  return result.data
}

async function getPagesLinks(ids) {
  const result = await axios.get(`${model.apiBasePath}/navigation`, {
    params: {
      ids: ids
    },
    paramsSerializer: params => {
      return qs.stringify(params)
    }
  })
  return result.data
}

async function getSiteMap() {
  const result = await axios.get(`${model.apiBasePath}/page/map`)
  return result.data
}

async function getClientSettings(code) {
  const result = await axios.get(`${model.apiBasePath}/clientsettings/${code}`)
  return result.data
}

async function sendSupportEmail(form) {
  await axios.post(`${model.apiBasePath}/feedback/support`, form)
}

async function sendFeedbackEmail(form) {
  await axios.post(`${model.apiBasePath}/feedback/feedback`, form)
}

async function getSearchResult(params) {
  const result = await axios.get(`${model.apiBasePath}/search`, { params: params })
  return result.data
}
async function getHeaderSettings() {
  const result = await axios.get(`${model.apiBasePath}/clientsettings/header`)
  return result.data
}

async function loginWelcomebook(email, password) {
  const result = await axios.post(`${model.apiBasePath}/Welcomebook`, { email, password })
  return result.data
}

async function getPageWelcomebook() {
  const result = await axios.get(`${model.apiBasePath}/page/getWelcomebook`)
  return result.data
}
async function sendResume(formData) {
  await axios.post(`${model.apiBasePath}/vacancy`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data' // Важливо вказати тип контенту
    }
  })
}

async function getImageFile(id, width, height) {
  const result = await axios.get(`${model.apiBasePath}/file/getImage`, { responseType: 'blob', params: { id: id, width: width, height: height } })
  var header = result.headers['content-disposition']
  header = header.slice(header.indexOf("UTF-8''") + 7)
  var fileName = header
  var file = new File([result.data], fileName, { type: result.data.type })
  return file
}

async function getPartner(id) {
  const result = await axios.get(`${model.apiBasePath}/partners/${id}`)
  return result.data
}

async function loginAskodChatUser(username, password) {
  const result = await axios.post(`${model.apiBasePath}/askodchat/loginAskodChatUser?username=${username}&password=${password}`)// ?username=${login}&password=${password}`, login)
  return result.data
}

async function deleteAskodChatUser(authToken, userId) {
  const result = await axios.post(`${model.apiBasePath}/askodchat/deleteUser?authToken=${authToken}&userId=${userId}`)// ?username=${login}&password=${password}`, login)
  return result.data
}

async function sendConsultationForm(form) {
  await axios.post(`${model.apiBasePath}/feedback/sendConsultationForm`, form)
}
